'use client';

import { useInvestorQuery } from '@/hooks/use-investor-query';
import { fetchInvestorPnl } from '../api/get-investor-pnl';
import { portfolioKeys } from '@/lib/investor-keys';
import { SLOW_CADENCE_MS } from '../api/keys';
import type { InvestorPnlQuery, InvestorPnlResponse } from '../types/api';

export function useInvestorPnl(params: InvestorPnlQuery = {}) {
  return useInvestorQuery<InvestorPnlResponse>({
    key: ({ address, chainId }) => portfolioKeys.pnl(address, chainId, params),
    fetch: ({ address, chainId }, signal) =>
      fetchInvestorPnl(address, chainId, params, signal),
    // A window aggregate moves with the daily valuation, not by the minute.
    // Polling it every 60s only added to a page that already fans out, and
    // the rate limiter is a hard budget shared by every screen.
    cadenceMs: SLOW_CADENCE_MS
  });
}
